import { Layout } from "antd";
import Notification from "../../../components/Notification";
import "../../../config/globals.css";
import { useFetchAnswer } from "../../../hooks/useFetchAnswer";
import { useEffect, useRef, useState } from "react";
import FactoryGuideSider from "../partials/factory-guide-sider.partial";
import FactoryHeader from "../partials/factory-header.partial";
import FactoryInput from "../partials/factory-input.partial";
import FactoryMessages from "../partials/factory-messages.partial";
import FactorySider from "../partials/factory-sider.partial";

const { Header, Content, Footer } = Layout;

export const FactoryView = () => {
    const { fetchAnswer, isLoading } = useFetchAnswer();
    const [messages, setMessages] = useState([
        { id: 1, sender: "Agente", text: "**¡Bienvenido a la Fábrica de Agentes!** \n\n Crea y personaliza tus propios agentes de IA. Comienza una nueva conversación para empezar.", time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }), isMine: false },
    ]);
    const [newMessage, setNewMessage] = useState("");
    const [isSiderVisible, setIsSiderVisible] = useState(false);
    const [hasSentMessage, setHasSentMessage] = useState(false);
    const messagesContainerRef = useRef(null);
    const inputRef = useRef(null);

    const scrollToBottom = () => {
        const container = messagesContainerRef.current;
        if (container) {
            container.scrollTop = container.scrollHeight;
        }
    };

    useEffect(() => {
        if (hasSentMessage) {
            scrollToBottom();
        }
    }, [messages, hasSentMessage]);

    const handleSendMessage = async (messageApi) => {
        if (newMessage.trim() === "") return;
        if (!hasSentMessage) setHasSentMessage(true);
        const userMessage = {
            id: Date.now(),
            sender: "Tú",
            text: newMessage,
            time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
            isMine: true,
        };
        setMessages([...messages, userMessage]);
        setNewMessage("");
        try {
            let text_response = "";
            const response = await fetchAnswer(newMessage);
            if (response.status === 200) {
                text_response = response.data.respuesta;
            } else if (response.status === 400) {
                text_response = response.data.detail;
            } else if (response.status === 401) {
                messageApi.warning({
                    description: response.data.detail,
                    duration: 5,
                    placement: "top",
                    className: "factory-message-notification",
                });
                return;
            }
            const serverMessage = {
                id: Date.now() + 1,
                sender: "Agente",
                text: text_response,
                time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
                isMine: false,
            };
            setMessages((prevMessages) => [...prevMessages, serverMessage]);
        } catch (error) {
            messageApi.error({
                description: "Error al obtener la respuesta. Intenta nuevamente.",
                duration: 5,
                placement: "top",
                className: "factory-message-notification",
            });
        }
        setTimeout(() => {
            inputRef.current?.focus();
        }, 0);
    };

    const styles = {
        header: {
            backgroundColor: "var(--color-primary)",
            color: "white",
            padding: "0 20px",
            alignItems: "center",
            display: "flex",
        },
        headerText: {
            fontSize: "16px",
            fontWeight: "bold",
        },
        content: {
            padding: "10px",
            backgroundColor: "#f5f5f5",
            overflowY: "auto",
        },
        messagesContainer: {
            display: "flex",
            flexDirection: "column",
            gap: "10px",
        },
        message: {
            maxWidth: "60%",
            padding: "0 10px",
            borderRadius: "10px",
            fontSize: "14px",
            lineHeight: "1.5",
            display: "flex",
            flexDirection: "column",
        },
        myMessage: {
            alignSelf: "flex-end",
            backgroundColor: "#b7dcfa",
        },
        otherMessage: {
            alignSelf: "flex-start",
            backgroundColor: "white",
        },
        time: {
            alignSelf: "flex-end",
            fontSize: "12px",
            color: "gray",
            marginTop: "0px",
        },
        footer: {
            backgroundColor: "white",
            borderTop: "1px solid #ddd",
            padding: "10px 20px",
            borderLeft: "1px solid #ddd",
            borderRight: "1px solid #ddd"
        },
    };

    return (
        <Notification>
            {(messageApi) => (
                <Layout style={{ height: "calc(100vh - 100px)", display: "flex" }}>
                    <FactorySider />
                    <Layout style={{ flex: 1, borderLeft: "1px solid #ffffff", borderRight: "1px solid #ffffff" }}>
                        <Header style={styles.header}>
                            <FactoryHeader
                                onToggleGuide={() => setIsSiderVisible(!isSiderVisible)}
                                isSiderVisible={isSiderVisible}
                                styles={styles}
                            />
                        </Header>
                        <Content style={{ ...styles.content, padding: 0 }}>
                            <div
                                ref={messagesContainerRef}
                                style={{
                                    flex: 1,
                                    overflowY: "auto",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "10px",
                                    height: "60vh",
                                    padding: "10px",
                                }}
                            >
                                <FactoryMessages messages={messages} styles={styles} />
                            </div>
                        </Content>
                        <Footer style={styles.footer}>
                            <FactoryInput
                                newMessage={newMessage}
                                setNewMessage={setNewMessage}
                                handleSendMessage={handleSendMessage}
                                isLoading={isLoading}
                                messageApi={messageApi}
                                styles={styles}
                                inputRef={inputRef}
                            />
                        </Footer>
                    </Layout>
                    {isSiderVisible && <FactoryGuideSider />}
                </Layout>
            )}
        </Notification>
    );
};
